export default {
    SET_WORKER_MANAGEMENT_BULK_EDIT_DIALOG_OPEN(state, isOpen) {
        state.isWorkerBulkEditDialogOpen = isOpen;
    },
    SET_SELECTED_BULK_EDIT_WORKER_CODE(state, list) {
        state.selectedBulkEditWorkerCodeList = list;
    },
};
